import { render, staticRenderFns } from "./QuestionsBreakdown.vue?vue&type=template&id=0b67d56e&"
import script from "./QuestionsBreakdown.vue?vue&type=script&lang=js&"
export * from "./QuestionsBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsBreakdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VDataTable,VRating})
